import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { IWorkflowRouting } from './workflowRouting.utils';

const defaultWorkflowRouting: IWorkflowRouting = {
    canEdit: null,
    canGLCode: null,
    canEditPOFields: null,
    canReassign: null,
};

const WorkflowRoutingContext = createContext<IWorkflowRouting>(defaultWorkflowRouting);

type WorkflowRoutingProviderProps = {
    children: ReactNode;
    workflowRouting: IWorkflowRouting | null | undefined;
};

export function WorkflowRoutingProvider({ children, workflowRouting }: WorkflowRoutingProviderProps) {
    const [workflowRoutingStored, setWorkflowRoutingStored] = useState<IWorkflowRouting>(defaultWorkflowRouting);

    useEffect(() => {
        if (workflowRouting != null) {
            setWorkflowRoutingStored(workflowRouting);
        }
    }, [workflowRouting]);

    return <WorkflowRoutingContext.Provider value={workflowRoutingStored}>{children}</WorkflowRoutingContext.Provider>;
}

export function useWorkflowRouting() {
    return useContext(WorkflowRoutingContext);
}
